(function () {
  if (window.__tsCrossSell) return;
  window.__tsCrossSell = true;

  var THRESHOLD = 6000; // 60,00 EUR in cents

  var CSS = '#ts-cross-sell{margin:0 0 18px}'
    + '#ts-cross-sell .tscs-banner{background:#e6f6ec;border:1px solid #bfe6cd;border-radius:12px;padding:14px 16px;margin-bottom:14px;text-align:center}'
    + '#ts-cross-sell .tscs-banner b{color:#1f9d55;font-size:18px}'
    + '#ts-cross-sell .tscs-banner .tscs-track{height:10px;border-radius:999px;background:#d5e8dc;overflow:hidden;margin-top:8px}'
    + '#ts-cross-sell .tscs-banner .tscs-fill{display:block;height:100%;background:#1f9d55;border-radius:999px;transition:width .5s ease}'
    + '#ts-cross-sell .tscs-title{margin:0 0 10px;font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:.03em}'
    + '#ts-cross-sell .tscs-list{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}'
    + '#ts-cross-sell .tscs-card{position:relative;border:1px solid #e3e3e3;border-radius:10px;padding:8px;text-align:center;font-size:12px;background:#fff}'
    + '#ts-cross-sell .tscs-card img{width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:6px}'
    + '#ts-cross-sell .tscs-name{display:block;margin:6px 0 2px;line-height:1.2;max-height:2.4em;overflow:hidden}'
    + '#ts-cross-sell .tscs-price{font-weight:700}'
    + '#ts-cross-sell .tscs-free{display:block;color:#1f9d55;font-weight:700;font-size:11px;margin-top:2px}'
    + '#ts-cross-sell .tscs-add{margin-top:6px;width:100%;border:0;border-radius:8px;padding:9px 0;background:#1f9d55;color:#fff;font-weight:700;font-size:12px;cursor:pointer}'
    + '#ts-cross-sell .tscs-add.is-plain{background:#111}'
    + '#ts-cross-sell .tscs-add[disabled]{opacity:.6}';

  function injectCSS() {
    if (document.getElementById('ts-cross-sell-css')) return;
    var s = document.createElement('style');
    s.id = 'ts-cross-sell-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function money(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function onCartPage() { return /\/cart(\/|$|\?)/.test(location.pathname + location.search) || !!document.querySelector('.cart-order__summary'); }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function getJSON(u) { return fetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  // Contenitore: pagina carrello (in cima al riepilogo) oppure drawer (dopo gli articoli)
  function ensureHost() {
    var h = document.getElementById('ts-cross-sell');
    if (h) return h;
    var page = document.querySelector('.cart-order__summary');
    if (page) { h = document.createElement('div'); h.id = 'ts-cross-sell'; page.insertBefore(h, page.firstChild); return h; }
    var li = document.querySelector('.cart-drawer__line-items');
    if (li && li.parentNode) { h = document.createElement('div'); h.id = 'ts-cross-sell'; li.parentNode.insertBefore(h, li.nextSibling); return h; }
    return null;
  }

  function select(cands, gap) {
    if (gap <= 0) return cands.slice().sort(function (a, b) { return a.price - b.price; }).slice(0, 6);
    var crossers = cands.filter(function (p) { return p.price >= gap && p.price <= gap + 2000; }).sort(function (a, b) { return a.price - b.price; });
    var fillers = cands.filter(function (p) { return p.price < gap; }).sort(function (a, b) { return b.price - a.price; });
    var seen = {}, out = [];
    crossers.concat(fillers).forEach(function (p) { if (!seen[p.id]) { seen[p.id] = 1; out.push(p); } });
    return out.slice(0, 6);
  }

  function paint(host, products, cart, gap) {
    var isPage = onCartPage();
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var cands = products.filter(function (p) {
      if (inCart[p.id]) return false;
      return (p.variants || []).some(function (v) { return v.available; });
    });
    var list = select(cands, gap);
    host.dataset.key = host.dataset.pendingKey || '';
    host.removeAttribute('data-loading');
    if (!list.length) { host.innerHTML = ''; return; }

    var html = '';
    // Banner grande solo sulla pagina carrello (l'intermedia)
    if (isPage) {
      var pct = Math.max(4, Math.min(100, Math.round((cart.total_price / THRESHOLD) * 100)));
      if (gap > 0) {
        html += '<div class="tscs-banner">Ti manca solo <b>' + money(gap) + '</b> alla SPEDIZIONE GRATIS'
          + '<span class="tscs-track"><span class="tscs-fill" style="width:' + pct + '%"></span></span></div>';
      } else {
        html += '<div class="tscs-banner"><b>Hai la spedizione gratis!</b></div>';
      }
    }

    var title = gap > 0 ? 'Aggiungi uno di questi e hai la spedizione gratis' : 'Completa il tuo ordine';
    html += '<p class="tscs-title">' + title + '</p><div class="tscs-list">';
    list.forEach(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.available; })[0];
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var crosser = (gap > 0 && p.price >= gap);
      var free = crosser ? '<span class="tscs-free">Con questo: spedizione gratis</span>' : '';
      var label = crosser ? 'Aggiungi → gratis' : '+ Aggiungi ' + money(p.price);
      html += '<div class="tscs-card">'
        + (img ? '<img loading="lazy" src="' + img + '" alt="">' : '')
        + '<span class="tscs-name">' + p.title + '</span>'
        + '<span class="tscs-price">' + money(p.price) + '</span>' + free
        + '<button class="tscs-add' + (crosser ? '' : ' is-plain') + '" type="button" data-variant="' + v.id + '">' + label + '</button>'
        + '</div>';
    });
    html += '</div>';
    host.innerHTML = html;
  }

  function populate(host) {
    if (host.dataset.loading) return;
    host.dataset.loading = '1';
    getCart().then(function (cart) {
      if (!cart.items.length) { host.innerHTML = ''; host.removeAttribute('data-key'); host.removeAttribute('data-loading'); return; }
      var seed = cart.items[0].product_id;
      var key = cart.item_count + ':' + cart.total_price + ':' + (onCartPage() ? 'p' : 'd');
      if (host.dataset.key === key) { host.removeAttribute('data-loading'); return; }
      host.dataset.pendingKey = key;
      var gap = THRESHOLD - cart.total_price;
      var base = '/recommendations/products.json?limit=10&product_id=' + seed + '&intent=';
      getJSON(base + 'related').then(function (d) {
        var p = (d && d.products) || [];
        if (p.length) { paint(host, p, cart, gap); return; }
        getJSON(base + 'complementary').then(function (d2) { paint(host, (d2 && d2.products) || [], cart, gap); });
      }).catch(function () { host.removeAttribute('data-loading'); });
    }).catch(function () { host.removeAttribute('data-loading'); });
  }

  function tick() { var h = ensureHost(); if (h) populate(h); }

  // "Aggiungi al carrello" (evento del tema) -> porta alla pagina carrello intermedia
  document.addEventListener('variant:add', function () {
    if (onCartPage()) { setTimeout(function () { location.reload(); }, 150); return; }
    setTimeout(function () { location.href = '/cart'; }, 120);
  });

  // Click sui prodotti del cross-sell
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#ts-cross-sell .tscs-add');
    if (!btn) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-variant'), 10);
    btn.disabled = true; btn.textContent = 'Aggiunto';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function () {
      if (onCartPage()) { location.reload(); }
      else { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }
    });
  });

  document.addEventListener('cart:refresh', function () { setTimeout(tick, 350); });

  var obs = new MutationObserver(function () {
    if (!document.querySelector('.cart-drawer__line-items') && !document.querySelector('.cart-order__summary')) return;
    var h = document.getElementById('ts-cross-sell');
    if (!h || (!h.dataset.key && !h.dataset.loading && !h.innerHTML)) tick();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { injectCSS(); tick(); });
  else { injectCSS(); tick(); }
})();
